import { render } from "./DetailComponent2.vue?vue&type=template&id=da913f0e&scoped=true"
import script from "./DetailComponent2.vue?vue&type=script&lang=js"
export * from "./DetailComponent2.vue?vue&type=script&lang=js"

import "./DetailComponent2.vue?vue&type=style&index=0&id=da913f0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da913f0e"]])

export default __exports__